import { CreateEntityTypeTargetInvestmentJurisdictionRequest } from '../../../../web-api-client';
import { EntityTypeInvestmentJurisdiction } from '../../models/entity-type-investment-jurisdiction';

export const mapEntityTypeInvJurisdictionRequest = (
  entityTypeInvJurisdiction: EntityTypeInvestmentJurisdiction
): CreateEntityTypeTargetInvestmentJurisdictionRequest => {
  return new CreateEntityTypeTargetInvestmentJurisdictionRequest({
    investmentJurisdictionId:
      entityTypeInvJurisdiction.investmentJurisdiction
        ?.investmentJurisdictionId,
    targetEntityTypeId:
      entityTypeInvJurisdiction.targetEntityType?.entityTypeId,
  });
};
